export default __webpack_public_path__ + "static/media/Bag.6e0688f0.svg";